// @flow
import React from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SimpleBar from 'simplebar-react';
import { useViewport } from 'components/templates/viewportProvider';
import { RestaurantActions } from 'modules/restaurant/actions';
import closeWhite from 'assets/images/closewhite.png';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  isOpen: boolean,
  onClosePress: () => void,
  modalContent?: string,
};

export const RestaurantMobileMenuModal = (props: Props) => {
  const { isMobile } = useViewport();
  const { isOpen, onClosePress, modalContent, toggleModal } = props;
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClosePress}
      overlayClassName={'modal-overlay normal-scroll'}
      className={`restaurant-menu-overlay ${isMobile ? 'mobile' : ''}`}
    >
      <div className={'restaurant-menu-modal'}>
        <a
          className={'collapse-icon-container'}
          onClick={() => toggleModal(false)}
        >
          <img src={closeWhite} alt={'icon'} />
        </a>
        {modalContent}
      </div>
    </Modal>
  );
};

const mapDispatchToProps = dispatch => {
  const { toggleModal } = RestaurantActions;
  return bindActionCreators(
    {
      toggleModal,
    },
    dispatch
  );
};

const connectedComponent = connect(
  null,
  mapDispatchToProps
)(RestaurantMobileMenuModal);

export default connectedComponent;
